import { Box, Text } from 'libComponents';

export default function CardLabel({ title, className }: { title: string; className?: string }) {
    return (
        <Box className={className}>
            <Text center text={title} type="overline" color="surface-default" />
        </Box>
    );
}
